import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
import {TextBold14, ThirtyText} from "@/app/components/texts";
import UserAvatar from "@/app/components/user_avatar/widget";
import Chip from "@/app/components/chip/widget";
import {OpenMatchModelResponse} from "@/app/api/open_match/models";
import {s} from "@/app/utils/s";
import {t} from "i18next";

interface Props {
  match: OpenMatchModelResponse;
  className?: string;
  onClick: (match: OpenMatchModelResponse) => void;
  isDesktop?: boolean;
  showOpensSpots?: boolean;
}

const GameRowWidget: React.FC<Props> = ({match, onClick, isDesktop = false, className, showOpensSpots = true}) => {
  const courtImage = match.court?.imagesUrls?.[0];
  const courtName = match.court?.name || "";
  const playerCount = match.countPlayers || 0;
  const maxPlayers = 4;
  const spotsOpen = maxPlayers - playerCount;
  // Format date as DD.MM
  const formattedDate = match.eventDate ? new Date(match.eventDate).toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit'
  }) : '';

  return (
    <div className={classNames(styles.container, {[styles.desktop]: isDesktop}, className)}
         onClick={() => onClick(match)}>
      <div className={styles.header}>
        <img
          src={courtImage || "https://app.padelmatchapp.com/static/media/auth_first.ba3208e7edc85629cc09.png"}
          alt={courtName}
          className={styles.image}
        />
      </div>
      <div className={styles.content}>
        <div className={styles.titleAndSubtitle}>
          <ThirtyText text={courtName} className={styles.title}/>
        </div>

        <div className={styles.infoRow}>
          {showOpensSpots && <TextBold14 text={t(s.spotsOpen, {count: spotsOpen})} className={styles.playerCount}/>}
          {formattedDate && <TextBold14 text={formattedDate} className={styles.date}/>}
          {match.timeRanges && <Chip text={match.timeRanges} className={styles.timeChip}/>}
        </div>

        <div className={styles.ownerAndSkillRow}>
          <div className={styles.owner}>
            {match.owner && (
              <>
                <div className={styles.ownerAvatar}>
                  <UserAvatar userAvatar={match.owner.imageLink} userName={match.owner.username || ""}/>
                </div>
                <TextBold14 text={match.owner.username || ""} className={styles.ownerName}/>
              </>
            )}
          </div>
          <div className={styles.skillLevel}>
            {match.skillLevel && <Chip text={match.skillLevel} className={styles.skillChip}/>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameRowWidget;